import { Typography } from '@curology/ui-components-web/react/Typography';
import React, { useEffect, useState } from 'react';

import { AnalyticsEvent, trackEvent } from '@/utils/analytics';

import DeepCleanseRxModal from './acneMultiRxUpsellComponents/deepCleanseRxModal';
import Disclaimers from './acneMultiRxUpsellComponents/disclaimers';
import FooterCtas from './acneMultiRxUpsellComponents/footerCtas';
import ProductCarousel from './acneMultiRxUpsellComponents/productCarousel';
import ProductComparison from './acneMultiRxUpsellComponents/productComparison';
import RoutineProducts from './acneMultiRxUpsellComponents/routineProducts';

const AcneMultiRxUpsell = ({
  discountAmountInCents,
  upsell,
}: {
  cleanserId: number | null;
  discountAmountInCents: number | null;
  upsell: string;
}) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    trackEvent(AnalyticsEvent.UPSELL_VIEWED, {
      upsell,
    });
  }, [upsell]);

  return (
    <>
      <div className="cur-max-w-[550px] cur-mx-auto lg:cur-px-6 lg:cur-py-8 cur-w-full">
        <Typography className="cur-text-surface-brand" size="h2">
          Special offer
        </Typography>
        <Typography className="cur-mb-4" size="h2">
          Upgrade your cleanser with Deep Cleanse<sup>Rx</sup>
        </Typography>
        <ProductComparison />
        <Typography className="cur-my-6" size="h2">
          <span className="cur-text-surface-brand">Tackle acne</span> from all
          angles, starting from deep in your pores
        </Typography>
        <ProductCarousel />
        <Typography className="cur-my-6" size="h2">
          Your routine, leveled up
        </Typography>
        <RoutineProducts />
        <Disclaimers
          discountAmountInCents={discountAmountInCents}
          setShowModal={setShowModal}
        />
      </div>
      <FooterCtas upsell={upsell} isModalOpen={showModal} />
      <DeepCleanseRxModal setShowModal={setShowModal} showModal={showModal} />
    </>
  );
};

export default AcneMultiRxUpsell;
